import { all, put, takeLatest } from 'redux-saga/effects';

import { types as salesTypes } from '../ducks/sales';

export function * watchSales() {
    yield takeLatest(salesTypes.SALES_RESET, onSalesReset);
    yield takeLatest(salesTypes.SALES_GET, onSalesGet);
    yield takeLatest(salesTypes.SALES_SUCCESS, onSalesGetResponse);
}

export function * onSalesReset({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onSalesGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onSalesGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'sales') {
        return yield all([
            put({
                type: salesTypes.SALES_SET,
                payload: response,
            }),
        ]);
    }
}
